import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import CampaignIcon from "@mui/icons-material/Campaign";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const CONTENT_OPTIONS = [
  {
    type: "Campanha",
    label: "Campanha",
    icon: CampaignIcon,
    description: "Campanhas comerciais e institucionais",
  },
  {
    type: "Banner",
    label: "Banner",
    icon: ViewCarouselIcon,
    description: "Banners para vitrine e home",
  },
  {
    type: "Lookbook",
    label: "Lookbook",
    icon: MenuBookIcon,
    description: "Catálogos visuais de coleção",
  },
  {
    type: "Video",
    label: "Vídeo",
    icon: OndemandVideoIcon,
    description: "Vídeos para YouTube, Vimeo ou upload",
  },
  {
    type: "Material",
    label: "Material",
    icon: PictureAsPdfIcon,
    description: "PDFs, imagens, links e arquivos",
  },
];

export default function DialogNovoConteudo({ open, onClose, onSelect }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ color: themeColorsDesingSystem.text.primary }}>
        <Typography
          variant="h4"
          component="span"
          style={{ color: themeColorsDesingSystem.text.primary }}
        >
          Novo Conteúdo
        </Typography>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
          aria-label="Fechar"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <List disablePadding>
          {CONTENT_OPTIONS.map((option) => {
            const Icon = option.icon;
            return (
              <ListItem
                button
                key={option.type}
                onClick={() => onSelect(option.type)}
                style={{
                  borderRadius: 8,
                  marginBottom: 4,
                  padding: "12px 8px",
                }}
              >
                <ListItemIcon style={{ minWidth: 48 }}>
                  <Icon
                    style={{ color: themeColorsDesingSystem.primary.main }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={option.label}
                  secondary={option.description}
                  primaryTypographyProps={{
                    style: {
                      fontWeight: 600,
                      color: themeColorsDesingSystem.text.primary,
                    },
                  }}
                  secondaryTypographyProps={{
                    style: { color: themeColorsDesingSystem.gray.dark },
                  }}
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
}
